module.exports = __webpack_public_path__ + "img/1507801198.533043cc.jpg";